
export default {
    giveUserFeedback(isError, msg) {
        window.localStorage.setItem("message_isError", isError ? "true" : "false");//javascript is broken man
        window.localStorage.setItem("message_content", msg);
    }
}